

















































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import {Action, Mutation, namespace, Getter, State} from 'vuex-class';
import {DateTime} from 'luxon';
import { rateState } from '../../store/RateReviewFaq';
import BTable from 'buefy/src/components/table/Table.vue';
import * as firebase from 'firebase/app';
import {MAFUser} from '@/store/User/types';
import { CommentQue } from '../../store/RateReviewFaq/types';

const commentsPath = 'rateState';
const commentsNamespace = namespace(commentsPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
        components: {
            AdminNavBar, BTable,
        },
    })
 export default class AdminComments extends Vue {
    @commentsNamespace.State('commentsQues') public Comments !: CommentQue[];
    @commentsNamespace.Action('getComments') public getComments: any;
    @commentsNamespace.Action('updateMAFComment') public updateMAFComment: any;


    public currentPage: number = 1;
    public checkboxPosition: any = 'left';
    public hasMobileCards: boolean = true;
    public defaultSortDirection: any = 'desc';
    public async created() {
            await this.getComments();
        }
    public formatDate(date: Date) {
            return DateTime.fromJSDate(date).toFormat(' LLLL d yyyy t');
        }
    public capitalize(name: string, userType: string) {
        if (userType === 'Organization') {
            return name;
        } else {
            const nameArray = name.split(' ');
            const firstName = nameArray[0].charAt(0).toUpperCase() + nameArray[0].slice(1);
            if (nameArray.length === 1) { return firstName; }
            return `${firstName} ${(nameArray[1][0]) ? nameArray[1][0].toUpperCase() + '.' : ''}`;
        }
    }
    /* tslint:disable:no-console */
    public async changeResolve(comment: CommentQue) {
      if (comment) {
        comment.resolved = (comment.resolved !== undefined) ? !comment.resolved : true;

        try {
          await this.updateMAFComment(comment);
        } catch (e) {
          console.error('Couldnt Update');
        }
      }
    }
 }
